import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import TrimFinished from './mA-trimFinished';

function MAInputTrim20({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onComponent(<TrimFinished />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="mA Input Trim"
      left="Back"
      right="Trim"
      caption="Set the mA input to 20.0 mA"
    />
  );
}

export default MAInputTrim20;
